module.exports = __webpack_public_path__ + "img/zhi-ye.2ee6c026.png";